module.exports = __webpack_public_path__ + "static/media/gold.65ae0655.png";